import { ActionType } from 'deox';
import { call, put } from 'redux-saga/effects';

import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';
import { updateUserAction } from '@/redux/actions/auth';
import { updateUser, TUpdateUserResponse } from '@/services/api/auth';

// FUNCTION
export function* updateUserSaga(action: ActionType<typeof updateUserAction.request>): Generator {
  const { materials, userId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(updateUser, materials, userId);
    const updateUserResponse: TUpdateUserResponse = response as TUpdateUserResponse;
    yield put(updateUserAction.success(updateUserResponse));
    successCallback?.(updateUserResponse);
  } catch (err) {
    yield put(updateUserAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.updateUserInfoError');
  }
}
